import { httpClient } from '../http-client';
import { Event } from './types';

export const eventsService = () => {
  const client = httpClient();
  const BASE_URL = '/v1/events';

  return {
    fetchEvents: async (terminal: string): Promise<Event[] | null> => {
      const url = `${BASE_URL}/${terminal}`;
      try {
        const result = await client.get<Event[]>(url);
        return result.data;
      } catch (e) {
        logger(`Error calling API: ${e}`);
        return null;
      }
    },
    createEvent: async (data: Event): Promise<Event | null> => {
      try {
        const result = await client.post<Event>(BASE_URL, data);
        return result.data;
      } catch (e) {
        logger(`Error calling API: ${e}`);
        return null;
      }
    },
    updateEvent: async (data: Event): Promise<Event | null> => {
      const url = `${BASE_URL}/${data.id}`;
      try {
        const result = await client.put<Event>(url, data);
        return result.data;
      } catch (e) {
        logger(`Error calling API: ${e}`);
        return null;
      }
    },
    deleteEvent: async (id: string): Promise<{} | null> => {
      const url = `${BASE_URL}/${id}`;
      try {
        const result = await client.delete<{}>(url);
        return result.data;
      } catch (e) {
        logger(`Error calling API: ${e}`);
        return null;
      }
    },
  };
};

const logger = (message: string): void => console.error(`[Events Service] ${message}`);
